"use client";

import React, { useEffect, useState } from "react";
import { Menu, X, ChevronRight } from "lucide-react";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger, SheetHeader, SheetTitle, SheetClose } from "@/components/ui/sheet";
export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const navLinks = [{
    title: "Home",
    path: "/HomePage"
  }, {
    title: "About Us",
    path: "/AboutUsPage"
  }, {
    title: "Products",
    path: "/Products"
  }, {
    title: "Markets",
    path: "https://trusting-sunbird.10web.cloud/markets/"
  }, {
    title: "Contact",
    path: "/ContactPage"
  }];
  return <header data-section-id="header" id="header" className={`sticky top-0 z-50 w-full transition-all duration-300 border-b ${isScrolled ? "bg-background/95 backdrop-blur-md border-border/80 shadow-sm" : "bg-background border-transparent"}`}>
      <div className="container mx-auto px-4 lg:px-8">
        <div className="flex h-16 sm:h-20 items-center justify-between">
          {}
          <div className="flex lg:hidden">
            <Sheet open={isOpen} onOpenChange={setIsOpen}>
              <SheetTrigger asChild>
                <Button variant="ghost" size="icon" aria-label="Open Menu">
                  <svg viewBox="0 0 24 24" className="size-7">
                    <circle cx="12" cy="12" r="10" fill="hsl(16 19% 17%)" />
                    <line x1="7" y1="9" x2="17" y2="9" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
                    <line x1="7" y1="12" x2="17" y2="12" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
                    <line x1="7" y1="15" x2="17" y2="15" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
                  </svg>
                </Button>
              </SheetTrigger>
              <SheetContent side="left" className="w-[300px] sm:w-[400px] p-0">
                <SheetHeader className="p-6 border-b text-left">
                  <SheetTitle>
                    <WvcLogo className="h-7 w-auto" />
                  </SheetTitle>
                </SheetHeader>
                <nav className="flex flex-col py-6">
                  {navLinks.map((link, i) => <SheetClose asChild key={link.path}>
                      <Link to={link.path} data-index={i} className="flex items-center justify-between px-6 py-4 text-sm font-bold uppercase tracking-widest text-foreground hover:bg-accent transition-colors border-b border-border/50 last:border-0">
                        {link.title}
                        <ChevronRight className="size-4 text-muted-foreground" />
                      </Link>
                    </SheetClose>)}
                </nav>
              </SheetContent>
            </Sheet>
          </div>

          {}
          <div className="flex items-center">
            <Link to="/" className="flex items-center transition-opacity hover:opacity-90">
              <WvcLogo className="h-7 sm:h-8 w-auto" />
            </Link>
          </div>

          {}
          <nav className="hidden lg:flex items-center gap-1">
            {navLinks.map((link, i) => <Link key={link.path} to={link.path} data-index={i} className="px-4 py-2 text-[13px] font-bold uppercase tracking-widest text-foreground/70 hover:text-foreground transition-colors relative group">
                {link.title}
                <span className="absolute bottom-0 left-4 right-4 h-0.5 bg-primary scale-x-0 group-hover:scale-x-100 transition-transform duration-200 origin-left" />
              </Link>)}
          </nav>

          {}
          <div className="flex items-center gap-4 lg:gap-8">
            <div className="h-6 w-px bg-border hidden md:block" />

            <Button variant="default" size="sm" className="rounded-lg px-5 font-bold uppercase tracking-widest text-[11px] h-10" asChild>
              <Link to="https://trusting-sunbird.10web.cloud/contact/">Inquiry</Link>
            </Button>
          </div>
        </div>
      </div>
    </header>;
}